import { Box } from '@rbilabs/universal-components';

import { theme } from 'styles/configure-theme';

export const QuestIncentiveWrapper = Box.withConfig({
  backgroundColor: theme.token('background-contrast-loyalty'),
});
